// modules/notifications/index.ts — Platik-IA
import { bus } from '../../core/event-bus';
import type { NotificationsAPI } from './contracts';

export async function initNotifications(): Promise<NotificationsAPI> {
  const api: NotificationsAPI = {
    show(message, type = 'info', duration = 4000) {
      bus.emit('notifications:show', { message, type, duration });
    },
    dispose() {},
  };

  bus.emit('notifications:ready');
  return api;
}
